import { Component, EventEmitter, Input, Output } from '@angular/core';
import moment from 'moment';
import { Coupon } from 'src/smoothr-web-app-core/models/Coupon';
import Customer from 'src/smoothr-web-app-core/models/Customer';
import Order from 'src/smoothr-web-app-core/models/Order';
import PromoCode from 'src/smoothr-web-app-core/models/PromoCode';

@Component({
	selector: 'app-coupon-items',
	templateUrl: './coupon-items.component.html',
	styleUrls: ['./coupon-items.component.scss'],
})
export class CouponItemsComponent {
	constructor() {}
	@Input() coupons: PromoCode[] = [];
	@Output() buttonClick = new EventEmitter<PromoCode>();
	@Input() customerData: Customer;
	@Input() order: Order;

	selectItem(item: PromoCode) {
		this.buttonClick.emit(item);
	}
	checkIfInOrder(item: PromoCode): boolean {
		return false;
		// return !!(this.order?.coupon || []).find(it => it?._id === item._id);
	}
	checkDate(item: PromoCode) {
		let avaible = {
			active: false,
			value: '',
		};
		if (item?.from) {
			if (moment().isBetween(moment(item.from), moment(item.to))) {
				return 'Ende at ' + moment(item.to).format('MM/DD/YYYY');
			}
			if (moment().isBefore(moment(item.from))) {
				return 'Start at ' + moment(item.from).format('MM/DD/YYYY');
			}
		}
	}
}
